import type { Phrases } from '../common/Phrases.d';
import type { ButtonGroupOption } from '../../../components/react-hook-form/ButtonGroup';

import React, { useMemo } from 'react';
// import { ButtonGroup } from '../../../components/react-hook-form/ButtonGroup';
import { ButtonRadioGroup } from '/react4xp/components/react-hook-form/buttonRadioGroup/ButtonRadioGroup';
import {
	SERVICES_ENUM_FIELD_NAME,
	SERVICES_FIELD_NAME,
	SERVICES_FREETEXT_FIELD_NAME,
	FIELD_VALUE_ANALYZED,
} from './constants';


export const AnalyzedButtonGroup = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {

	const OPTIONS: ButtonGroupOption[] = useMemo(() => [{
		label: phrases['notificationForm.services.analyzedField.value.yes'],
		value: FIELD_VALUE_ANALYZED.YES,
	},{
		label: phrases['notificationForm.services.analyzedField.value.no'],
		value: FIELD_VALUE_ANALYZED.NO,
	},{
		label: phrases['notificationForm.services.analyzedField.value.unknown'],
		value: FIELD_VALUE_ANALYZED.UNKNOWN,
	}], [phrases]);

	return (
		<ButtonRadioGroup
			afterClick={({newValue, setValue}) => {
				if (newValue !== FIELD_VALUE_ANALYZED.YES) {
					// ERROR: Setting value to empty string on enums
					// or literal unions causes validation to fail!
					setValue(SERVICES_ENUM_FIELD_NAME.ANALYZED_HOW, undefined);

					// Yes, empty string can be set on optional text fields.
					setValue(SERVICES_FREETEXT_FIELD_NAME.ANALYZED_RESULT, '', { shouldValidate: true });
				}
			}}
			className='z-0'
			description={phrases['notificationForm.term.chooseOne']}
			label={phrases['notificationForm.services.analyzedField.label']}
			name={SERVICES_FIELD_NAME.ANALYZED}
			options={OPTIONS}
		/>
	);
};
